import styled from 'styled-components';
import CardCover from './CardCover';
import CardDetails from './CardDetails';
import { SearchResult } from '../../types';
import { PropertySearchResult } from '../../dtos';
import Link from 'next/link';
import { EntityTypes } from '../../../../new-lib/constants/common';
import { logEvent } from '../../../../new-lib/analytics';
import { useRouter } from 'next/router';
import CompoundCardDetails from './compound-card/CompoundCardDetails';

interface CardProps {
  searchResult: SearchResult;
  index: number;
}

const Card = ({ searchResult, index }: CardProps) => {
  const { locale, asPath } = useRouter();

  function isPropertySearchResult(
    searchResult: SearchResult
  ): searchResult is PropertySearchResult {
    return (searchResult as PropertySearchResult).property_type !== undefined;
  }

  const handleCardClick = () => {
    logEvent.click('cmpnd_click', 'search_page', 'search', {
      ...(isPropertySearchResult(searchResult)
        ? {
            cmpnd_id: searchResult.compound.id,
            cmpnd_name: searchResult.compound.name,
            area_id: searchResult.area.id,
            area_name: searchResult.area.name,
            dev_id: searchResult.developer.id,
            dev_name: searchResult.developer.name,
            entity_type: EntityTypes.PROPERTY,
            index: index,
            ...(searchResult.has_offers && {
              badges: [locale == 'en' ? 'Offer Included' : 'عرض متاح']
            })
          }
        : {
            cmpnd_id: searchResult.id,
            cmpnd_name: searchResult.name,
            area_id: searchResult.areaId,
            area_name: searchResult.areaName,
            dev_id: searchResult.developerId,
            dev_name: searchResult.developerName,
            entity_type: EntityTypes.COMPOUND,
            index: index,
            ...(searchResult?.badges &&
              searchResult?.badges?.length > 0 && {
                badges: [
                  ...(searchResult.hasOffer
                    ? [locale === 'en' ? 'Offer Included' : 'عرض متاح']
                    : []),
                  ...searchResult.badges.map(badge => badge.name)
                ]
              })
          })
    });
  };

  return isPropertySearchResult(searchResult) ? (
    <Link
      href={{
        pathname: `/compound/${searchResult.compound?.slug}/property/${searchResult.slug}`
      }}
      prefetch
      onClick={handleCardClick}
    >
      <Container>
        <CardCover
          id={searchResult.id}
          slug={searchResult.slug}
          index={index}
          area={searchResult.area}
          coverImage={searchResult.image}
          price={searchResult.min_price}
          entityType={EntityTypes.PROPERTY}
          {...{
            compound: searchResult.compound,
            recommended: searchResult.recommended ?? false,
            tags: searchResult.tags
          }}
        />

        <CardDetails entity={searchResult} />
      </Container>
    </Link>
  ) : (
    <Link
      href={{
        pathname: `/compound/${searchResult.slug}`
      }}
      prefetch={false}
      onClick={handleCardClick}
    >
      <Container>
        <CardCover
          id={searchResult.id}
          slug={searchResult.slug}
          index={index}
          area={searchResult.areaName}
          coverImage={searchResult.imageUrl}
          price={searchResult.developerPlan?.minPrice}
          entityType={EntityTypes.COMPOUND}
          {...{}}
        />

        <CompoundCardDetails entity={searchResult} />
      </Container>
    </Link>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 16px;
  padding: 8px;
  border-radius: 12px;
  border: 1px solid #d3dbe6;

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    flex-direction: column;
    padding: 0;
    padding-bottom: 16px;
    height: auto;
  }
`;

export default Card;
